type UpdateMessage = {
  img?: string
  title: string
  body?: string
}

type UpdateMessages = {
  [version: string]: UpdateMessage
}

export const updateMessages: UpdateMessages = {
  '5.0': {
    img: '/img/svg/newest-update.svg',
    title: 'Welkom bij de nieuwe mijnZiekenhuis app!',
    body: 'Vanaf nu kan je rechtstreeks met je dokter communiceren',
  },
  '6.0': {
    img: '/img/svg/newest-update.svg',
    title: 'De app is vernieuwd!',
    body: 'Taken, agenda en berichten kregen een update.',
  },
  '6.1': {
    img: '/img/svg/appointment-booking.svg',
    title: 'Afspraken boeken was nooit zo simpel',
  },
}

/**
 * Get major.minor version from semver string
 * Example: "6.1.5" -> "6.1"
 */
export const getMajorMinorVersion = (version: string): string => {
  const parts = version.split('.')
  if (parts.length >= 2) {
    return `${parts[0]}.${parts[1]}`
  }
  return version
}
